import {RangeDatePicker} from '@/components/commons/range-date-picker/RangeDatePicker'
import {DashboardConsultantSearchParams} from '@/features/dashboard/types'
import {useParsedSearchParams} from '@/hooks/useParsedSearchParams'
import {formatDateToSearchParams} from '@/features/medical-records/utils'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {DashboardUserFilter} from '../dashboard-user-filter/DashboardUserFilter'

export const DashboardConsultantFilters = () => {
    const {searchParams, setSearchParams} = useParsedSearchParams(DashboardConsultantSearchParams)

    return (
        <Flexbox gap={2}>
            <RangeDatePicker
                values={
                    searchParams.endDate && searchParams.startDate
                        ? {from: new Date(searchParams.startDate), to: new Date(searchParams.endDate)}
                        : {from: undefined, to: undefined}
                }
                onClear={() => setSearchParams({endDate: undefined, startDate: undefined})}
                onConfirm={({from, to}) =>
                    from && to ? setSearchParams(formatDateToSearchParams({startDate: from, endDate: to})) : undefined
                }
            />
            <DashboardUserFilter />
        </Flexbox>
    )
}
